import {Shinglaselector} from 'app.vue.components.shinglaselector';
import {Choice as ChoiceController} from 'app.controllers.choice'

export const Choice = {
    components: {
            Shinglaselector: Shinglaselector,
        },
    props: {
        defaulttileid: {default: 0},
        templateurl: {default: false},
    },
	data () {
		return {
            form: {
                tile: false
            },
		}
	},
	created ()
	{
        
	},
    computed: { //s(){return this.$store.state},

    },
    methods: {
        
    },
    watch: {
		'form.tile' (val,oval)
        {
            if (this.form.tile?.ID) {
                let complects = new ChoiceController(this.$el.closest('main'));
                complects.setTile(this.form.tile.ID);
            }
            
        }
    },
	template: `
    <div>
        <shinglaselector
                v-model="form.tile"
                v-bind:defaulttileid="defaulttileid"
                v-bind:templateurl="templateurl"
            ></shinglaselector>
    </div>
	`
}
